/** Posição do fantasma — mesma ordem do OMR: calibração no molde, depois homografia para o scan bruto. */

function applyHomography3x3(H, x, y) {
  if (!H || H.length !== 9) return [x, y];
  const [a, b, c, d, e, f, g, h, i] = H;
  const w = g * x + h * y + i;
  if (Math.abs(w) < 1e-9) return [x, y];
  return [(a * x + b * y + c) / w, (d * x + e * y + f) / w];
}

/** Calibração fina no molde canônico (idêntica ao backend). */
export function applyOverlayCalibration(xNorm, yNorm, imgW, imgH, prefs) {
  const w = imgW || 1;
  const h = imgH || 1;
  const s = (prefs?.scale ?? 100) / 100;
  const sx = (prefs?.scaleX ?? 100) / 100;
  const ox = prefs?.offsetX ?? 0;
  const oy = prefs?.offsetY ?? 0;
  const xn = Math.max(0, Math.min(1, 0.5 + (xNorm - 0.5) * s * sx + ox / w));
  const yn = Math.max(0, Math.min(1, yNorm * s + oy / h));
  return { xn, yn, s };
}

/** Posição final no PNG bruto do scanner. */
export function mapPreviewBubbleCoords(xNorm, yNorm, rNorm, imgW, imgH, prefs, homography) {
  const { xn, yn, s } = applyOverlayCalibration(xNorm, yNorm, imgW, imgH, prefs);
  const [xr, yr] = applyHomography3x3(homography, xn, yn);
  const xFinal = Math.max(0, Math.min(1, xr));
  const yFinal = Math.max(0, Math.min(1, yr));
  return {
    cx: xFinal * imgW,
    cy: yFinal * imgH,
    r: Math.max(4, rNorm * imgW * 1.15 * s),
  };
}

/** @deprecated use mapPreviewBubbleCoords */
export function mapOverlayBubbleCoords(xNorm, yNorm, rNorm, imgW, imgH, prefs) {
  return mapPreviewBubbleCoords(xNorm, yNorm, rNorm, imgW, imgH, prefs, null);
}
